import React from 'react';
import HeroImage from '../../../assets/images/services/banking-license/hero-image.png'
import PageBanner from '../../../assets/images/services/banking-license/page-banner.png'
import BreadCrumbs from "../../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../../components/Constant/List/List";
import { GiCheckMark } from "react-icons/gi";
import { GoDotFill } from "react-icons/go";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import CTA from "../../../components/Constant/cta/CTA";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Button from "../../../components/Constant/button/Button";

const BreadCrumbsData = [
    { name: 'Offshore Advisory', link: '/' },
    {
        name: 'Financial License – Anjouan (Comoros)',
        link: '/financial-license-anjouan',
    },
]

function BankingLicenseMalta () {

    return (
        <main className='main'>
            <section className='banking-license-section section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='banking-license-container container'>

                    <h1 className='section-title'>
                        Banking License – Malta (MFSA/ECB)
                    </h1>

                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>
                                Establish a Credit Institution in the European Union
                            </h3>
                            <p className='page-paragraph'>
                                <b>Malta</b> is one of <b>Europe’s most respected financial hubs</b>, offering <b>full banking licenses</b> under the <b>Malta Financial Services Authority (MFSA)</b>, subject to approval by the <b>European Central Bank (ECB)</b>. A <b>Maltese Banking License (Credit Institution License)</b> grants the right to <b>accept deposits, issue loans, and provide full banking services</b> across the <b>European Economic Area (EEA)</b> under <b>EU passporting rights</b>.
                            </p>
                            <PageList
                                items={[
                                    {
                                        title: "Commercial Banking",
                                        icon: GoDotFill,
                                    },
                                    {
                                        title: "Private Banking",
                                        icon: GoDotFill,
                                    },
                                    {
                                        title: "Digital/Neo Banking",
                                        icon: GoDotFill,
                                    },
                                    {
                                        title: "Investment Banking",
                                        icon: GoDotFill,
                                    },
                                ]}
                            />
                            <Button
                                text="Request a Malta Banking Proposal →"
                                link="/consultation"
                                type="primary"
                                size="large"
                            />
                        </div>

                        <HeroRightImage src={HeroImage} />
                    </div>

                    <BannerPageImg src={PageBanner} />
                    <b/><br/>

                    <div className='flex-start'>
                        <h3 className='page-title'>Why Choose Malta for Banking?</h3>
                        <PageList
                            items={[
                                {
                                    title: "EU Recognition",
                                    paragraph: "Tier-1 credibility as part of the EU & ECB framework",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Regulated by MFSA & ECB",
                                    paragraph: "Dual oversight ensures maximum trust",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "EU Passporting",
                                    paragraph: "Operate banking services across all EEA countries",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "SWIFT, IBAN & SEPA Access",
                                    paragraph: "Full integration with EU banking networks",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Stable Jurisdiction",
                                    paragraph: "Trusted by institutional investors and regulators",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Services Covered by a Maltese Banking License</h3>
                        <PageList
                            items={[
                                {
                                    title: "Accepting Deposits from Clients",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Issuing Loans & Credit Lines",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Providing Corporate & Private Banking",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Offering Debit/Credit Card Programs",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Multi-Currency Accounts & International Transfers",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Custody & Investment Banking Services",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Digital/Neo Banking with Fintech Integrations",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Capital & Compliance Requirements</h3>
                        <PageList
                            items={[
                                {
                                    title: "Minimum Capital",
                                    paragraph: "€5,000,000 (fully paid-up)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Fit & Proper Test",
                                    paragraph: "Applied to all shareholders, directors, and officers",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Local Presence",
                                    paragraph: "Physical office and resident directors in Malta",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Ongoing Compliance",
                                    paragraph: "Strict AML/KYC frameworks, risk management, and annual audits",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "ECB Approval",
                                    paragraph: "Mandatory, as all EU banking licenses require joint supervision",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Benefits of a Malta Banking License</h3>
                        <PageList
                            items={[
                                {
                                    title: "Top-Tier Global Recognition",
                                    paragraph: "Tier-1 jurisdiction",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "EU & ECB Supervision",
                                    paragraph: "Maximum credibility with regulators",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Access to Payment Networks",
                                    paragraph: "Visa, Mastercard, SEPA, SWIFT",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Investor Confidence",
                                    paragraph: "Maltese banks enjoy higher institutional trust",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Scalability",
                                    paragraph: "From private banking to full commercial banking",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Licensing Process</h3>
                        <PageList
                            items={[
                                {
                                    title: "Consultation & Structuring",
                                    paragraph: "Define banking model (commercial, private, digital)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Pre-Application Review",
                                    paragraph: "Prepare business plan, governance, and risk framework",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Application Submission",
                                    paragraph: "Filed with MFSA, reviewed in cooperation with ECB",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Due Diligence & Interviews",
                                    paragraph: "Review of shareholders, management, AML/KYC systems",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Approval & Licensing",
                                    paragraph: "Final approval granted jointly by MFSA & ECB",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Operational Readiness",
                                    paragraph: "Compliance, IT, and banking software integration",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Timeline & Costs</h3>
                        <PageList
                            items={[
                                {
                                    title: "Timeline",
                                    paragraph: "12–18 months (longer than offshore jurisdictions)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Setup Costs",
                                    paragraph: "From €200,000+ (legal, compliance, advisory fees)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Capital Requirement",
                                    paragraph: "€5,000,000 minimum",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual Supervision Costs",
                                    paragraph: "Audits, compliance, and MFSA/ECB fees",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Why Offshore Advisory?</h3>
                        <PageList
                            items={[
                                {
                                    title: "Experts in EU Banking License Applications",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "End-to-End Support",
                                    paragraph: "Incorporation, license application, compliance, audits",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Introductions to Core Banking Software Providers & Payment Networks",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Comparison Guidance",
                                    paragraph: "Malta vs Offshore (Mwali, Anjouan, Western Sahara)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Full Project Management Until License Approval",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                            ]}
                        />


                    </div>

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>
                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />
                    <CTA
                        title="Looking for EU Tier-1 banking credibility?"
                        description=
                            "A <b>Malta Banking License</b> offers <b>global recognition</b>, <b>EU passporting</b>, and <b>ECB oversight</b>. While more demanding than <b>offshore centers</b>, it is the <b>gold standard for international banking projects</b>."
                        buttonText="Book a Malta Banking License Consultation →"
                        buttonLink="/consultation"
                    />
                </div>
            </section>
        </main>
    );
}

export default BankingLicenseMalta;

const faqData = [
    {
        question: "How recognized is a Maltese banking license?",
        content: [
            { type: "answer", text: "It is among the most prestigious globally, on par with Luxembourg and Ireland." },
        ],
    },
    {
        question: "How much capital is required?",
        content: [
            { type: "answer", text: "Minimum €5 million fully paid-up." },
        ],
    },
    {
        question: "How long does it take to obtain a license?",
        content: [
            { type: "answer", text: "Typically 12–18 months, depending on the complexity of the project." },
        ],
    },
    {
        question: "Can I launch a digital/neo bank under Malta?",
        content: [
            { type: "answer", text: "Yes — many fintech banks operate under Maltese banking licenses." },
        ],
    },
    {
        question: "Do I need local directors in Malta?",
        content: [
            { type: "answer", text: "Yes — at least two fit & proper resident directors and a compliance officer." },
        ],
    },
];

const testimonialsData = [
    {
        quote:
            "Our private banking setup in Malta was approved after 14 months. Offshore Advisory guided us through MFSA and ECB requirements.",
        author: "James P.",
        role: "Banking Investor",
    },
    {
        quote:
            "We launched a fintech-focused bank in Malta. Offshore Advisory managed licensing, compliance, and PSP onboarding.",
        author: "Elena M.",
        role: "Digital Bank Founder",
    },
];